import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface StatItem {
  label: string;
  value: ReactNode;
  cls?: string;
}

interface Props {
  items: StatItem[];
  className?: string;
}

export function StatsGrid({ items, className }: Props) {
  return (
    <div className={cn('grid grid-cols-2 gap-3 mb-6', className)}>
      {items.map((item) => (
        <div key={item.label} className='p-4 rounded-2xl border border-border/30 bg-card'>
          <div className='text-xs text-muted-foreground mb-1'>{item.label}</div>
          <div className={cn('text-xl font-bold', item.cls)}>{item.value}</div>
        </div>
      ))}
    </div>
  );
}
